import Event from '../../utils/event';
import DOM from '../../utils/dom';
import {SYSTEM_EVENTS} from '../../events/events';
import {PRIORITY_LEVEL} from '../../services/overlay_manager/overlay_manager_levels';
import {TYPES} from '../../services/overlay_manager/overlay_manager_types';
import BaseComponent from "../../base/base_component";

export default class LoadingIndicator extends BaseComponent {
    static CLASS = 'LoadingIndicator';

    _isShowingHimself = false;
    _isClosingHimself = false;
    _loader = null;
    _loaderWrapper = null;

    showLoadingIndicator() {
        this._loaderWrapper = DOM.$$('<div>');
        this._loader = DOM.$$('<div>');

        DOM.addClass(this._loaderWrapper, ['cgp-loader']);
        this.addChildrenElements();
        DOM.append(this._loaderWrapper, this._loader);

        this._isShowingHimself = true;
        try {
            Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, {
                el: this._loaderWrapper,
                type: TYPES.FULL_SCREEN,
                priority: PRIORITY_LEVEL.GAME_LOADING_INDICATOR,
                additionalClasses: ['cgp-overlay-gamewindow'],
                isCloseBtnAllowed: false
            });
        }
        finally {
            this._isShowingHimself = false;
        }


        this.onSystemEvent([SYSTEM_EVENTS.OPEN_OVERLAY, SYSTEM_EVENTS.LOGIN_FORM_OPEN, SYSTEM_EVENTS.LOCATION_POPUP_OPEN], this._onOtherOverlayOpen);
        this.onSystemEvent([SYSTEM_EVENTS.CLOSE_OVERLAY, SYSTEM_EVENTS.LOGIN_FORM_CLOSE, SYSTEM_EVENTS.LOCATION_POPUP_CLOSED], this._onOtherOverlayClose);
    }

    addChildrenElements() {
        DOM.addClass(this._loader, 'cgp-loading');
    }

    closeLoadingIndicator() {
         this._isClosingHimself = true;
         try {
             Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: PRIORITY_LEVEL.GAME_LOADING_INDICATOR});
         }
         finally {
             this._isClosingHimself = false;
         }
    }

    _otherOverlaysOpenCount = 0;

    _onOtherOverlayOpen(data) {
        if (this._isShowingHimself) {
            return;
        }
        this._otherOverlaysOpenCount++;
        this.closeLoadingIndicator();

        if(data?.priority === PRIORITY_LEVEL.GAME_FRAME) {
            this.shutDown();
        }
    }

    _onOtherOverlayClose() {
        if (this._isClosingHimself) {
            return;
        }
        this._otherOverlaysOpenCount--;
        if (this._otherOverlaysOpenCount === 0) {
            this.showLoadingIndicator();
        }
    }
}